module.exports = __webpack_public_path__ + "img/lk.adfaea9c.png";